var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.content)+" "),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.showCopyIcon)?_c('v-icon',_vm._g(_vm._b({staticClass:"behavior_action_icon",attrs:{"small":"","color":"grey"},on:{"click":_vm.copyToClipboard}},'v-icon',attrs,false),on),[_vm._v("mdi-content-copy")]):_vm._e()]}}])},[_vm._v(" Copy to clipboard ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }